// https://github.com/kazupon/vue-i18n/issues/474
import enJson from './en.json';
import deJson from './de.json';

export const languages = {
  en: enJson,
  de: deJson,
};

export const defaultLocale = 'en';
export const fallbackLocale = 'de';
